<script>
    import DropdownItem from './DropdownItem.svelte';
    import UploadModel from 'models/UploadModel'
    import ToggleSwitch from 'views/components/toggleSwitch/ToggleSwitch.svelte'
    import Icon from 'views/components/icon/Icon.svelte'

    const {
        label = null,
        icon = null,
        hasToggle = false,
        toggleState = false,
        subItems = null,
        isSubItem = false,
        uploadDetails = null,
        callback = () => {},
        closeDropdown = () => {}
    } = $props();

    let uploadModel
    let toggleSwitch = $state()

    function onClickItem() {
        if (hasToggle) {
            toggleSwitch.toggleState()
            return
        }

        callback()
        closeDropdown()
    }

    function addUploadModel(buttonElement) {
        if (uploadDetails) {
            uploadModel = new UploadModel({
                ...uploadDetails,
                element: jQuery(buttonElement)
            })
            uploadModel.on('change:url', (model) => {
                callback(model)
            })
        }
    }
</script>

{#if subItems}
    <details>
        <summary class="dropdown-item">
            {#if icon}
                <div class="icon">
                    <Icon name={icon}></Icon>
                </div>
            {/if}
            {#if label}
                <div class="label">{label}</div>
            {/if}
            <div class="arrow">
                <Icon name="arrow-down"></Icon>
            </div>
        </summary>
        <div>
            {#each subItems as item (item.label)}
                <DropdownItem {...item} isSubItem={true} {closeDropdown}></DropdownItem>
            {/each}
        </div>
    </details>
{:else}
    <button
        class="dropdown-item"
        class:sub-item={isSubItem}
        use:addUploadModel
        onclick={onClickItem}
    >
        {#if icon}
            <span class="icon">
                <Icon name={icon}></Icon>
            </span>
        {/if}

        {#if hasToggle}
            <span class="toggle">
                <ToggleSwitch bind:this={toggleSwitch} isChecked={toggleState} {callback}></ToggleSwitch>
            </span>
        {/if}

        {#if label}
            <span class="label">{label}</span>
        {/if}
    </button>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding: 0;
  font-size: 1rem;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  color: #122d40;
  border: none;
  border-radius: 12px;
  list-style: none;
}
.dropdown-item::-webkit-details-marker {
  display: none;
}
.dropdown-item:hover {
  background-color: hsl(40, 20%, 96%);
}
.dropdown-item.sub-item {
  margin-top: 4px;
  background: hsl(27, 15%, 93%);
}
.dropdown-item.sub-item:last-child {
  margin-bottom: 4px;
}
.dropdown-item.sub-item:hover {
  color: #000;
}
.dropdown-item .label {
  padding-left: 1rem;
  padding-right: 1rem;
  white-space: nowrap;
}
.dropdown-item .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
}
.dropdown-item .icon :global(svg) {
  width: 20px;
  height: 20px;
  fill: hsl(205, 60%, 44%);
}
.dropdown-item .toggle {
  padding-left: 1rem;
}
.dropdown-item .arrow {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}
.dropdown-item .arrow :global(svg) {
  display: flex;
  width: 20px;
  height: 20px;
  margin-right: 1rem;
  fill: #122d40;
  transition: transform 0.25s;
}

details[open] .dropdown-item .arrow :global(svg) {
  transform: rotate(180deg);
}</style>
